<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pull-left">
        <router-link to="/marketing/offers" class="btn btn-orange"><i class="ti-arrow-left"></i> {{$t('general.back')}}</router-link>
      </div>
      <p  class="clearfix"></p>
      <offers-form @on-submit="onOfferSubmit"></offers-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import OffersForm from './OffersForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      OffersForm
    },
    data () {
      return {
        offerModel: {},
        offer: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onOfferSubmit (model, isValid) {
        this.offerModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/OffersAdd.vue